<div class="error">
  <div class="container error__container">
    <span class="error__number">403</span>
    <p class="error__message">
      Это ошибка, из-за которой вы попали в параллельную реальность сайта Банковского портала. С ней уже разбираются,
      но вы можете <a class="error__link" routerLink="/">зайти на главную страницу</a>
    </p>
  </div>
</div>
